import React, { useEffect } from "react";
import "../Pages/CleeQ.css";
import "../Pages/Responsive.css";
import { makeStyles } from "@material-ui/core/styles";
import Aos from "aos";
import "aos/dist/aos.css";
import ContactUs from "./ContactUs";
import PresidentSpeech from "./PresidentSpeech";
import "../Components/NavBar/NavBar.css";
import NavBar from "../Components/NavBar/NavBar";
import SocialHeadings from "../Components/SocialHeadings";


const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

function AboutUs() {
  useEffect(() => {
    Aos.init({ duration: 1000 });
    window.scrollTo(0, 0); // This will scroll the page to the top when the component mounts
  }, []);

  const classes = useStyles();

  return (
    <div>
      <header className="SoleraSticky">
      <div className="SocialHeadings-Display">
          <SocialHeadings />
        </div>
        <NavBar />
      </header>

      {/* <div id="Home">
        <OurLanding />
      </div> */}
      <div className="SoleraBody3">
        <div className="container AboutUsLanding landing-page-container">
          <div className="LandingWrapper">
            <div className="LandingContainer">
              <div className="LandingCoverUp20">
                <div className="SolersFeaturesHeading">About Us</div>
              </div>
              <div className="Who-We-Are">
                <div className="AboutCont">
                  <div className="AboutContHeading" data-aos="zoom-in-up">
                    Who we are
                  </div>
                  <br />

                  <p className="SoleraIntro1">
                    Welcome to UNILAG Alumni UK, where excellence meets legacy!
                    We're a community of extraordinary individuals who've
                    graduated from the University of Lagos, Nigeria, and have
                    become trailblazers in the UK. More than former students,
                    we're a family bonded by shared experiences and a commitment
                    to meaningful connections. <br />
                    <br />
                    Unilag Alumni UK offers entertaining events, seminars,
                    networking, and mentorship programs to help you thrive
                    personally and professionally. As part of the Unilag family,
                    we actively contribute to the university's development.{" "}
                    <br />
                    <br />
                    Whether you're seeking professional connections, lifelong
                    friendships, or a chance to give back, we welcome you. Let's
                    redefine alumni communities, soar to new heights, and make a
                    lasting impact together. Join us today and be part of our
                    extraordinary journey!
                  </p>
                </div>
                <div className="AboutCont2">
                  <div className="container-fluid p-0">
                    <div className="row">
                      <div className="col">
                        <div className="border">
                          <div className="WhoImg">
                            <img
                              src="/assets/solera/Sen.jpeg"
                              alt=""
                              className="WhoImgAbout "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="VisionContainer">
                <div className="LandingHedings10" data-aos="zoom-in-up">
                  Our Vision
                </div>

                <p className="SoleraIntro1">
                  To establish a vibrant and inclusive network for the
                  University of Lagos graduates <br />
                  residing in the UK, fostering the exchange of knowledge,
                  ideas, and experiences to <br /> empower and strengthen the
                  alumni community.
                </p>
              </div>
              <br />
              <br />
              <div>
                <div className="LandingHedings10" data-aos="zoom-in-up">
                  Our Mission
                </div>

                <p className="SoleraIntro1">
                  To establish a lasting heritage that honors our
                  accomplishments, safeguards our <br />
                  traditions, and prepare the path for generations to come.
                </p>
              </div>

              <br />
              <br />
              <div className="VisionContainer2">
                <div className="LandingHedings10" data-aos="zoom-in-up">
                  Our Goals
                </div>

                <p className="SoleraIntro1">
                  Our team members share core values that are rooted in:
                  <br />
                  1. To provide support and empowerment to the next generation
                  of alumni <br />
                  2. To transform the alumni community into a wellspring of
                  inspiration for <br /> emerging leaders and young individuals.
                </p>
              </div>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
      {/* <div id="Events">
        <Events />
      </div> */}
      {/* <div id="News">
        <News />
      </div>
      <div id="Projects">
        <Projects />
      </div>

      <div id="Excos">
        <Excos />
      </div> */}

      {/* <div id="Membership">
        <Membership />
      </div> */}
      <div id="">
        <PresidentSpeech />
      </div>
      {/* <div id="Gallery">
        <Gallery />
      </div> */}

      <div id="Photo Gallery">
        <ContactUs />
      </div>
    </div>
  );
}

export default AboutUs;
